let nextOverlayId = 1;
interface OverlayEntry {
  id: number;
  priority: number;
}

const openOverlays: OverlayEntry[] = [];

/**
 * Tracks modal surfaces in mount order so only the visually topmost surface
 * handles Escape. This keeps a dialog opened from a drawer from closing both
 * layers with one key press.
 */
export function registerOverlay(priority = 0): number {
  const id = nextOverlayId++;
  openOverlays.push({ id, priority });
  return id;
}

export function unregisterOverlay(id: number | null | undefined): void {
  if (id == null) return;
  const index = openOverlays.findIndex((entry) => entry.id === id);
  if (index >= 0) openOverlays.splice(index, 1);
}

/**
 * True while any registered surface (dialog, side sheet, popover, viewer) is
 * open. Page-level keyboard shortcuts use it to stay silent behind overlays.
 */
export function hasOpenOverlay(): boolean {
  return openOverlays.length > 0;
}

export function isTopOverlay(id: number | null | undefined): boolean {
  if (id == null || openOverlays.length === 0) return false;
  const top = openOverlays.reduce((current, candidate) =>
    candidate.priority >= current.priority ? candidate : current,
  );
  return top.id === id;
}
